import { useEffect, useReducer } from 'react';
import reducer from './reducer';
import getActions from './getActions';
import { ICompaniesAllState } from '@/creditflowresearch/application/League/interfaces';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';

interface IProps {
  companiesAllInitialState: ICompaniesAllState,
}

export default ({ companiesAllInitialState }:IProps) => {
  const [state, dispatch] = useReducer(reducer, companiesAllInitialState);
  const { page, perPage } = state;
  const { state: filtersState } = useLeagueTableFiltersContext();
  const selectedPeriod = filtersState.periods.leagueTable.selected;
  const searchText = filtersState.search.value;

  const actions = getActions({ page, perPage, selectedPeriod, searchText }, dispatch);

  useEffect(() => {
    const { data: collection, totalCount } = companiesAllInitialState;

    actions.setCompaniesAllData({ collection, totalCount });
  }, [companiesAllInitialState]);

  return {
    state,
    ...actions,
  };
};
